const APP_FOOTER = `\u00A9 ${new Date().getFullYear()} — Windsor Telecom - all rights reserved.`
const APP_TITLE = 'My Wallboard'

module.exports = {
    APP_FOOTER,
    APP_TITLE
}
